var _path, _path2, _circle, _path3, _path4, _circle2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonitorsProblems(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 147,
    viewBox: "0 0 138 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69 13C86.2391 13 102.772 19.8482 114.962 32.0381C127.152 44.2279 134 60.7609 134 78C134 95.2391 127.152 111.772 114.962 123.962C102.772 136.152 86.2391 143 69 143",
    stroke: "#F44336",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69 143C60.4641 143 52.0117 141.319 44.1256 138.052C36.2394 134.786 29.0739 129.998 23.038 123.962C17.0022 117.926 12.2144 110.761 8.94782 102.874C5.68127 94.9882 4 86.5359 4 78C4 69.464 5.68128 61.0117 8.94785 53.1255C12.2144 45.2394 17.0023 38.0738 23.0381 32.038C29.0739 26.0022 36.2395 21.2144 44.1256 17.9478C52.0118 14.6813 60.4641 13 69.0001 13",
    stroke: "#F44336",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 18,
    r: 18,
    fill: "#F44336"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38 28.5C43.799 28.5 48.5 23.799 48.5 18C48.5 12.201 43.799 7.5 38 7.5C32.201 7.5 27.5 12.201 27.5 18C27.5 23.799 32.201 28.5 38 28.5Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38 30C31.3726 30 26 24.6274 26 18C26 11.3726 31.3726 6 38 6C44.6274 6 50 11.3726 50 18C50 24.6274 44.6274 30 38 30Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(1 0 0 -1 36.5 24)",
    fill: "#F44336"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 7.5,
    rx: 1.5,
    transform: "matrix(1 0 0 -1 36.5 19.5)",
    fill: "#F44336"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorsProblems);
export default __webpack_public_path__ + "static/media/monitors-problems.961520cb0c9f312392f0a08c3b5a7eab.svg";
export { ForwardRef as ReactComponent };